import { createSlice } from "@reduxjs/toolkit";

export const LOADING_REDUCER = 'loading';

const initialState = {
    loading: false,
    loadingComponent: false
};

export const loadingSlice = createSlice({
    name: LOADING_REDUCER,
    initialState,
    reducers: {
        setLoading(state, { payload }) {
            state.loading = payload
        },
        setLoadingComponent(state, { payload }) {
            state.loadingComponent = payload
        },

    },
});

export const selectLoading = (state) => state[LOADING_REDUCER].loading;
export const selectLoadingComponent = (state) => state[LOADING_REDUCER].loadingComponent;


export const {
    setLoading,
    setLoadingComponent
} = loadingSlice.actions;

export default loadingSlice.reducer